import api from "./api";

let scriptPromise = null;
function loadCheckout() {
  if (window.Razorpay) return Promise.resolve(true);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = () => resolve(true);
      s.onerror = () => { scriptPromise = null; resolve(false); };
      document.body.appendChild(s);
    });
  }
  return scriptPromise;
}

// Opens Razorpay Checkout for a pack or custom credit amount. Resolves with
// { status: "paid", balance } | { status: "failed", message } | { status: "cancelled" }.
export async function payWithRazorpay({ packageId, credits }) {
  if (!(await loadCheckout())) return { status: "failed", message: "Couldn't load Razorpay. Check your connection and try again." };
  const { data: order } = await api.post("/payments/order", packageId ? { package_id: packageId } : { credits });
  return new Promise((resolve) => {
    let settled = false;
    let lastError = null;
    const done = (r) => { if (!settled) { settled = true; resolve(r); } };
    const rzp = new window.Razorpay({
      key: order.key_id,
      order_id: order.order_id,
      amount: order.amount,
      currency: order.currency,
      name: "Stealth Assistance",
      description: order.label,
      prefill: { email: order.email, name: order.name },
      theme: { color: "#C8C8C8" },
      handler: async (resp) => {
        try {
          const { data } = await api.post("/payments/verify", resp);
          done({ status: "paid", balance: data.balance, credits: data.credits });
        } catch (e) {
          done({ status: "failed", message: e?.response?.data?.detail || "Payment could not be verified. No credits were added." });
        }
      },
      modal: {
        ondismiss: async () => {
          if (settled) return;
          if (lastError) {
            await api.post("/payments/failed", { order_id: order.order_id, ...lastError }).catch(() => {});
            done({ status: "failed", message: lastError.reason || "Payment failed." });
          } else {
            await api.post("/payments/cancel", { order_id: order.order_id }).catch(() => {});
            done({ status: "cancelled" });
          }
        },
      },
    });
    rzp.on("payment.failed", (resp) => {
      // Razorpay keeps the modal open so the user can retry; we record the failure when they close it.
      lastError = { reason: resp?.error?.description || "Payment failed", code: resp?.error?.code || "" };
      api.post("/payments/failed", { order_id: order.order_id, ...lastError }).catch(() => {});
    });
    rzp.open();
  });
}
